import React from 'react';

export default () => {
    return (
        <div style={{display:'flex', height: '200px', justifyContent:'center', alignItems: 'center'}}>
            No se encontraron parámetros para mostrar un tabulado.
        </div>
    );
}
